export default __webpack_public_path__ + "static/media/link-disable-2.dbefecd7.svg";